import React from "react";
import { Route, Routes } from "react-router-dom";
import IndexAllReports from "./allReports/IndexAllReports";
import GenerateReport from "./allReports/components/GenerateReport";
import GenerateClassBasedReport from "./allReports/components/GenerateClassBasedReport";
import { guardElement } from "@comps/components";

const ReportsModules = () => {
  return (
    <Routes>
      <Route path="all-reports" element={ guardElement(<IndexAllReports modkey="reportsAll"/>, "reportsAll") } />
      <Route path="all-reports/generate/:id" element={ guardElement(<GenerateReport modkey="reportsAll" />, "reportsAll") } />
      <Route path="all-reports/generate-class/:id" element={ guardElement(<GenerateClassBasedReport modkey="reportsAll" />, "reportsAll") } />

    </Routes>
  );
}

export default ReportsModules;
